import { metadataConfig } from 'shared/domains/metadata';
export const getProperties = () => {
    const GENERAL_INFORMATION = [
        {
            id: 'metadataDocumentContractOwner',
            config: metadataConfig.get('ContractOwner'),
        },
        {
            id: 'metadataDocumentCountry',
            config: metadataConfig.get('Country'),
        },
        {
            id: 'metadataDocumentDocumentCategory',
            config: metadataConfig.get('DocumentCategory'),
        },
        {
            id: 'metadataDocumentType',
            config: metadataConfig.get('DocumentType'),
        },
        {
            id: 'metadataDocumentMaterialAgreement',
            config: metadataConfig.get('MaterialAgreement'),
        },
        {
            id: 'metadataDocumentOriginalVersionStored',
            config: metadataConfig.get('OriginalVersionStored'),
        },
        {
            id: 'metadataDocumentParties',
            config: metadataConfig.get('Parties'),
        },
    ];
    const LIFECYCLE_AND_STATUS = [
        {
            id: 'metadataDocumentActive',
            config: metadataConfig.get('Active'),
        },
    ];
    const DATES = [
        {
            id: 'metadataDocumentNoticeDate',
            config: metadataConfig.get('NoticeDate'),
        },
        {
            id: 'metadataDocumentProbationaryPeriodExpirationDate',
            config: metadataConfig.get('ProbationaryPeriodExpirationDate'),
        },
        {
            id: 'metadataDocumentStartDate',
            config: metadataConfig.get('StartDate'),
        },
        {
            id: 'metadataDocumentTerminationDate',
            config: metadataConfig.get('TerminationDate'),
        },
    ];
    const COMMERCIAL = [
        {
            id: 'metadataDocumentCurrency',
            config: metadataConfig.get('Currency'),
        },
        {
            id: 'metadataDocumentDiscount',
            config: metadataConfig.get('Discount'),
        },
        {
            id: 'metadataDocumentFeeAdjustmentClause',
            config: metadataConfig.get('FeeAdjustmentClause'),
        },
        {
            id: 'metadataDocumentPaymentTermsDaysFromInvoiceDate',
            config: metadataConfig.get('PaymentTermsDaysFromInvoiceDate'),
        },
        {
            id: 'metadataDocumentTotalContractCost',
            config: metadataConfig.get('TotalContractCost'),
        },
        {
            id: 'metadataDocumentTotalContractValue',
            config: metadataConfig.get('TotalContractValue'),
        },
    ];
    const RENEWAL_AND_TERMINATION = [
        {
            id: 'metadataDocumentAutomaticRenewal',
            config: metadataConfig.get('AutomaticRenewal'),
        },
        {
            id: 'metadataDocumentNoticePeriodDays',
            config: metadataConfig.get('NoticePeriodDays'),
        },
        {
            id: 'metadataDocumentNoticePeriodMonths',
            config: metadataConfig.get('NoticePeriodMonths'),
        },
        {
            id: 'metadataDocumentOriginalTermMonths',
            config: metadataConfig.get('OriginalTermMonths'),
        },
        {
            id: 'metadataDocumentPostTerminationObligations',
            config: metadataConfig.get('PostTerminationObligations'),
        },
        {
            id: 'metadataDocumentRenewalTermMonths',
            config: metadataConfig.get('RenewalTermMonths'),
        },
        {
            id: 'metadataDocumentTerminationForCause',
            config: metadataConfig.get('TerminationForCause'),
        },
        {
            id: 'metadataDocumentTerminationForConvenience',
            config: metadataConfig.get('TerminationForConvenience'),
        },
    ];
    const LIABILITY_AND_RISK = [
        {
            id: 'metadataDocumentIndemnity',
            config: metadataConfig.get('Indemnity'),
        },
        {
            id: 'metadataDocumentLiabilityCap',
            config: metadataConfig.get('LiabilityCap'),
        },
        {
            id: 'metadataDocumentLiabilityCapScope',
            config: metadataConfig.get('LiabilityCapScope'),
        },
        {
            id: 'metadataDocumentLimitationOfLiability',
            config: metadataConfig.get('LimitationOfLiability'),
        },
    ];
    const HR = [
        {
            id: 'metadataDocumentProbationaryPeriod',
            config: metadataConfig.get('ProbationaryPeriod'),
        },
    ];
    const REGULATORY = [
        {
            id: 'metadataDocumentDeviateFromStandard',
            config: metadataConfig.get('DeviateFromStandard'),
        },
        {
            id: 'metadataDocumentGoverningLaw',
            config: metadataConfig.get('GoverningLaw'),
        },
        {
            id: 'metadataDocumentOutsourcing',
            config: metadataConfig.get('Outsourcing'),
        },
        {
            id: 'metadataDocumentProcessingOfPersonalData',
            config: metadataConfig.get('ProcessingOfPersonalData'),
        },
    ];
    const properties = [
        ...GENERAL_INFORMATION,
        ...LIFECYCLE_AND_STATUS,
        ...DATES,
        ...COMMERCIAL,
        ...RENEWAL_AND_TERMINATION,
        ...LIABILITY_AND_RISK,
        ...HR,
        ...REGULATORY,
    ];
    return properties.map((property) => (Object.assign(Object.assign({}, property.config), { id: property.id })));
};
